import type { ResolveCreationModifier } from "./types";

export const resolveCreationModifier: ResolveCreationModifier = ({
  isEditingElement,
  isMultiAddModeEnabled,
  isCtrlLikePressed,
  isShiftPressed,
}) => {
  if (isEditingElement) return "ctrl";
  if (isMultiAddModeEnabled) return "shift";
  if (isCtrlLikePressed) return "ctrl";
  if (isShiftPressed) return "shift";
  return "none";
};
